import PropTypes from 'prop-types';

const TextSmall = ({ children, center = false }) => (
  <p className={`text-xs leading-4 text-pj-gray-800 ${center && 'text-center'}`}>
    {children}
  </p>
);

TextSmall.propTypes = {
  center: PropTypes.bool,
  children: PropTypes.string.isRequired,
};

export default TextSmall;
